import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack, Link, mergeStyles } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { PrimaryButton, StepWrapperCompletionConfirmation } from '../components';
import { useAutoBiddingFac } from '../hooks';

const completionConfirmationStyles = mergeStyles({
  width: 600,
});

export const CompletionConfirmation = (props) => {
  const {
    coupon,
    selectedCampaigns,
    onClose,
  } = props;

  const serverContext = useContext(ServerContext);
  const i18n = useContext(I18nContext);

  const { getFormattedCurrencyValue } = useAutoBiddingFac();

  const couponDetailsUrl = useMemo(
    () => `${serverContext.ServicesEndpoints.ClientCenterUIAPI}Billing/CouponDetails?cid=${serverContext.CurrentCustomer.Id}&aid=${serverContext.CurrentAccount.Id}`,
    [serverContext.CurrentAccount.Id, serverContext.CurrentCustomer.Id, serverContext.ServicesEndpoints.ClientCenterUIAPI]
  );

  const formattedCouponValue = useMemo(() => getFormattedCurrencyValue(coupon.CouponValue), [coupon.CouponValue, getFormattedCurrencyValue]);
  const formattedCouponUpfrontSpend = useMemo(() => getFormattedCurrencyValue(coupon.CouponUpfrontSpend), [coupon.CouponUpfrontSpend, getFormattedCurrencyValue]);

  return (
    <StepWrapperCompletionConfirmation selectedCampaigns={selectedCampaigns} coupon={coupon} onClose={onClose}>
      <div className={classNames(completionConfirmationStyles, 'completion-confirmation')}>
        {i18n.getString(_TL_('Your coupon is now activated! When you spend {0} on your selected campaigns, your advertising credit of {1} will be automatically redeemed.'))
        .replace('{0}', formattedCouponUpfrontSpend)
        .replace('{1}', formattedCouponValue)}
        {' '}
        <Link href={couponDetailsUrl}>{i18n.getString(_TL_('Learn more about your coupon details and claim status.'))}</Link>
        <Stack horizontal horizontalAlign="end" className="footer" styles={{ root: { marginTop: 12 } }}>
          <PrimaryButton text={i18n.getString(_TL_('Close'))} onClick={onClose} className="close-button" />
        </Stack>
      </div>
    </StepWrapperCompletionConfirmation>);
};

CompletionConfirmation.propTypes = {
  coupon: PropTypes.shape({
    CouponUpfrontSpend: PropTypes.number.isRequired,
    CouponValue: PropTypes.number.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  selectedCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
